module.exports = __webpack_public_path__ + "static/img/gb_jcjg_icon.png";